<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">BD材料</span>
      <!-- <span class="zn-text-grey">选择您要的行业和公司性质，点击打包下载可以直接下载</span> -->
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="margin:10px 0">
        <b style="margin-right:10px">所属行业：</b>
        <el-select v-model="hangye" size="mini">
          <el-option
            v-for="(item, idx) in hangyeList"
            :key="idx"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div
        v-if="hangye"
        class="box-content"
      >
        <el-row
          v-for="(item, idx) in src[hangye].list"
          v-if="item.md5"
          :key="idx"
          type="flex"
          align="middle"
          style="margin-bottom:20px!important"
        >
          <el-col :span="5"> {{ item.label }}</el-col>
          <el-col :span="13">
            <el-button
              type="text"
              style="margin-left:10px"
              @click="preview(item.md5)"
            >{{
              item.name
            }}</el-button>
          </el-col>
          <el-col
            :span="6"
            style="display:flex;justify-content:flex-end"
          >
            <el-button
              type="primary"
              size="mini"
              @click="download({ md5: item.md5 })"
            >下载附件</el-button>
          </el-col>
        </el-row>
      </div>
      <div style="border-top:1px dashed #ccc;padding-top:5px">
        <el-row
            v-for="(item, idx) in otherSrc"
            v-if="item.md5"
            :key="idx"
            type="flex"
            align="middle"
            style="margin-bottom:20px!important"
          >
            <el-col :span="5"> {{ item.label }}</el-col>
            <el-col :span="13">
              <el-button
                type="text"
                style="margin-left:10px"
                @click="preview(item.md5)"
              >{{
                item.name
              }}</el-button>
            </el-col>
            <el-col
              :span="6"
              style="display:flex;justify-content:flex-end"
            >
              <el-button
                type="primary"
                size="mini"
                @click="download({ md5: item.md5 })"
              >下载附件</el-button>
            </el-col>
          </el-row>
      </div>
    </div>
    <!-- <div v-if="src[hangye].zip" class="zn-template-submit" @click="download({ md5: src[hangye].zip })">打包下载</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      hangyeList: ['不限', '公募基金', '证券', 'PEVC', '医药', '金融科技', '医疗器械', '芯片', '汽车','银行理财子'],
      hangye: '不限',
      src: {
        不限: {
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍.pptx',
              md5: 'b898b0258abf914bb0fa3df73d9203c2',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '行业咨询PPT',
              name: '阿尔法公司介绍-咨询版本.pptx',
              md5: '6447b36d2ddfacc40577fbd00e5d7638',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
            {
              label: '年度报告',
              name: '阿尔法咨询2022-2023金融行业人才市场年度报告.pdf',
              md5: '52e9675e7054ddf8a624ef9ba80ea5e2',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '阿尔法公司介绍-投行条线-202304.pptx',
              md5: 'd9b616001e3e2f290398a204695ec211',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '公募-案例分析-交银施罗德人才培养理念.pptx',
              md5: '0f4e603a7258d500c19bd74526deeeaf',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '公募-筹备期公募-20220505.pptx',
              md5: '4f161dc3ba61d17293a7fb3b26d788c6',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '公募-绩优股票基金经理招聘解决方案-202210.pdf',
              md5: '985084363e272ca281db30a2c683f291',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '公募-绩优股票基金经理招聘解决方案-202210.pptx',
              md5: 'e574e7248784b6bbe61d2bde3c2c7159',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '公募券商-二级行业研究员的选用育留实践-2022.12.31.pdf',
              md5: '423be133210f8ac3d78e02f147eae674',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '股权投资-科技投资招聘保代流动.pptx',
              md5: '0f380c3bc55f9a529797101baeba6ce7',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '金控集团-高管招聘.pdf',
              md5: 'a18cc99f17e545ff5b23b90a1f084ce1',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '券商-投行股强创收团队&保代群体分析-2022年.pdf',
              md5: 'da7b4f43a3d84182a17e1a5fac7fdf1b',
            },
            {
              label: '解决方案BD PPT（金融）',
              name: '券商资管公募-数据分析在资管行业人力资源管理中的应用-20230423.pptx',
              md5: 'c6a638a6a5d838cb53ad846f101e9c2a',
            },
            {
              label: '阿尔法智人科技高新企业证书',
              name: '北京阿尔法智人科技高新企业证书.pdf',
              md5: '07f69cb526dcc3ece1807baac1172e86',
            },
          ],
        },
        公募基金: {
          // zip: '8ca22b893589ce4e243c121b087a862e',
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-公募资管.pptx',
              md5: '5558e899f5a976c30e4a214cd3aef33d',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法团队介绍',
              name: '阿尔法团队优势及详情介绍',
            },
            {
              label: '擅长职位和成功案例',
              name: '成功案例-资管方向.xlsx',
              md5: '2420baf32a318dfd6971d402e4a608a4',
            },
            {
              label: '典型人才简历',
              name: '资管方向-典型人才简历',
            },
            {
              label: '职位搜寻报告',
              name: '资管-职位搜寻报告-固收投资高管.xlsx',
              md5: 'c1db8c776b7bfdc924b1209083f592df',
            },
            {
              label: '年度报告',
              name: '公募基金VIP客户专享-2022-2023金融行业人才市场年度报告.pdf',
              md5: 'beaed7ece13647d4f49a4451b19bef56',
            },
            {
              label: '薪酬报告',
              name: '公募基金固收条线激励机制-阿尔法咨询.xlsx',
              md5: '0cd46bb415c174ad4762c1715f13d52c',
            },
            {
              label: 'Mapping报告',
              name: '资管-Mapping报告-主动量化负责人.xlsx',
              md5: 'fbf993102d825ab5fd32a3b062cc66dc',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
            {
              label: '解决方案BD PPT',
              name: '公募-案例分析-交银施罗德人才培养理念.pptx',
              md5: '0f4e603a7258d500c19bd74526deeeaf',
            },
            {
              label: '解决方案BD PPT',
              name: '公募-筹备期公募-20220505.pptx',
              md5: '4f161dc3ba61d17293a7fb3b26d788c6',
            },
            {
              label: '解决方案BD PPT',
              name: '公募-绩优股票基金经理招聘解决方案-202210.pdf',
              md5: '985084363e272ca281db30a2c683f291',
            },
            {
              label: '解决方案BD PPT',
              name: '公募-绩优股票基金经理招聘解决方案-202210.pptx',
              md5: 'e574e7248784b6bbe61d2bde3c2c7159',
            },
            {
              label: '解决方案BD PPT',
              name: '公募券商-二级行业研究员的选用育留实践-2022.12.31.pdf',
              md5: '423be133210f8ac3d78e02f147eae674',
            },
            {
              label: '解决方案BD PPT',
              name: '券商资管公募-数据分析在资管行业人力资源管理中的应用-20230423.pptx',
              md5: 'c6a638a6a5d838cb53ad846f101e9c2a',
            },
          ],
        },
        证券: {
          // zip: '94065d03c633d05c9a96e43f23cbb371',
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-证券行业.pptx',
              md5: '0540203f334198d80260afc3b7aed76d',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法团队介绍',
              name: '阿尔法团队优势及详情介绍',
            },
            {
              label: '擅长职位和成功案例',
              name: '擅长方向-券商2.xlsx',
              md5: '212912b4440705e3cd1dffd19d8a6616',
            },
            {
              label: '典型人才简历',
              name: '资管方向-典型人才简历',
            },
            {
              label: '职位搜寻报告',
              name: '券商-职位搜索报告-广深地区-ABS团队长.xlsx',
              md5: '315d113744f9480cd3fc095f00e01ca8',
            },
            {
              label: '年度报告',
              name: '证券行业VIP客户专享-2022-2023金融行业人才市场年度报告.pdf',
              md5: '8b508d0d45cac99596f5cd9889d396b7',
            },
            {
              label: '薪酬报告',
              name: '券商-薪酬职级报告.xlsx',
              md5: '0b368aa0424d52d1f6b1a2221db38db1',
            },
            {
              label: 'Mapping报告',
              name: '券商-Mapping报告.xlsx',
              md5: '0705a2227ee812940c8b857eea86d17c',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
            {
              label: '解决方案BD PPT',
              name: '公募券商-二级行业研究员的选用育留实践-2022.12.31.pdf',
              md5: '423be133210f8ac3d78e02f147eae674',
            },
            {
              label: '解决方案BD PPT',
              name: '券商-投行股强创收团队&保代群体分析-2022年.pdf',
              md5: 'da7b4f43a3d84182a17e1a5fac7fdf1b',
            },
            {
              label: '解决方案BD PPT',
              name: '券商资管公募-数据分析在资管行业人力资源管理中的应用-20230423.pptx',
              md5: 'c6a638a6a5d838cb53ad846f101e9c2a',
            },
          ], 
        },
        PEVC: {
          // zip: 'e39db1ee117521d38fc6c3f0fbd023fc',
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-私募股权.pptx',
              md5: '440d0f1c2c2554a4bdf57ea701511a2e',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法团队介绍',
              name: '阿尔法公司优势及详情介绍.pdf',
              md5: '3b5743afad2776debc60e3d258423af8',
            },
            {
              label: '职位搜寻报告',
              name: '私募股权-职位搜寻报告_20200601.xlsx',
              md5: 'de628f9d781ef534ac4402b58000919f',
            },
            {
              label: '年度报告',
              name: '股权投资VIP客户专享-2022-2023金融行业人才市场年度报告.pdf',
              md5: 'c29b187424d5b4e368ba6f62c33ee341',
            },
            {
              label: '薪酬报告',
              name: '薪酬报告-股权投资薪酬报告.pptx',
              md5: '37f35b9ca2fe35426b3577f15d23df60',
            },
            {
              label: 'Mapping报告',
              name: 'PEVC目标公司Mapping报告.xlsx',
              md5: '25dbc787ad8b6178cc4a5b00278ef5c0',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
            {
              label: '解决方案BD PPT',
              name: '股权投资-科技投资招聘保代流动.pptx',
              md5: '0f380c3bc55f9a529797101baeba6ce7',
            },
            {
              label: '解决方案BD PPT',
              name: '如何招到能真正解决问题的IR-阿尔法IR招聘解决方案.pdf',
              md5: '070d6f2a64ccf871f303ef7dcd53ffbd',
            },
          ],
        },
        医药: {
          // zip: '76486257f8602bacfab434fb03126f4a',
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-医药医疗.pptx',
              md5: 'b923b0ea42dba579187fe6f42425ebf5',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '医药薪酬图片',
              name: '医药薪酬图片.pdf',
              md5: 'ddf3b8a4dd495a6064bba4e5f45c8110',
            },
            {
              label: '医药-薪酬报告',
              name: '医药-薪酬报告.xlsx',
              md5: '6ed0ae90a1317ffdab2fca807f6d9e8b',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
        金融科技: {
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-金融科技.pptx',
              md5: 'c65f5efde883b6ce27e31c68b29994b6',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
        医疗器械: {
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-医疗器械（编辑版）.pptx',
              md5: '6fcf267450d984b1d443ab07ee3b447e',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
        芯片: {
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-芯片.pptx',
              md5: 'a001802cdf92b52517dca64165ef2838',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
        汽车: {
          list: [
            {
              label: '阿尔法公司介绍PPT',
              name: '阿尔法公司介绍-汽车（编辑版）.pptx',
              md5: 'afe218d9073f9731d28fe2e87e0373bb',
            },
            {
              label: '阿尔法公司介绍PPT英文版',
              name: 'CompanyIntroduction-Alpha.pptx',
              md5: '13b593783d669717e9a3ccc1ec186fb3',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
        银行理财子: {
          list: [
            {
              label: '解决方案BD PPT',
              name: '阿尔法咨询银行理财行业研究-1.11.pptx',
              md5: '1e86bc8a2b188c61364c24b3dc10c6d4',
            },
            {
              label: '阿尔法合同模版',
              name: '【中文版】2021阿尔法招聘服务合同（包含过程激励）.docx',
              md5: '981c8aa0ac34385eec8e128da6906836',
            },
            {
              label: '阿尔法英文合同模版',
              name: '【英文版】2021阿尔法招聘服务合同.docx',
              md5: '593132468e8a21b52a0ab31b436cb18f',
            },
            {
              label: '阿尔法服务方案',
              name: '阿尔法服务方案和服务承诺.pdf',
              md5: 'aeb7ac598004d137ca7861c0ea58bf26',
            },
          ],
        },
      },
      otherSrc: [
        {
          label: '人力资源许可证',
          name: '人力资源许可证.pdf',
          md5: 'e38c0ae09178c734d14f0f49e3c7076d'
        },
        {
          label: '浙江阿尔法营业执照正本',
          name: '浙江阿尔法营业执照正本.pdf',
          md5: '05d4b21e10d4f2256b8a089b23f26a0e'
        },
        {
          label: '阿尔法智人高新企业证书',
          name: '北京阿尔法智人科技高新企业证书.pdf',
          md5: '07f69cb526dcc3ece1807baac1172e86',
        },
      ]
    }
  },
  methods: {
    generateSafyUrl(url) {
      if (location.origin.indexOf('https://') !== -1) {
        url = url.replace('http://', 'https://')
      } else if (location.origin.indexOf('http://') !== -1) {
        url = url.replace('https://', 'http://')
      }
      return url
    },
    async download(params) {
      if (typeof params !== 'object') {
        throw new Error('下载参数错误')
      }
      const { _id, fileId, md5, originalname, url, preview } = params
      let a = document.createElement('a')
      a.style.display = 'none'
      a.target = '_blank'
      if (!preview) a.download = originalname || ''
      if (url) {
        a.href = this.generateSafyUrl(url)
      } else if (md5 || _id || fileId) {
        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        try {
          const { src } = await window.app.service('file').fetchFileURL(Object.assign(query, { preview }))
          a.href = this.generateSafyUrl((!src.includes('http') ? window.host : '') + src)
        } catch (e) {
          window.alert((e.response && e.response.message) || e.message)
          console.error(e)
          return
        }
      }
      a.click()
      a = null
      window.app.service('radish').addKpi({ type: 'downloadfile', content: params })
    },
    async preview(md5) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile({ md5 })
      ref.show()
    },
  }
}
</script>
